import { IntegrationV2ResponseSchema } from "@redotech/internal-ctx-client";
import * as z from "zod";

const integrationTypeSchema = z.enum([
  "META",
  "GA4",
  "KLAVIYO",
  "POSTSCRIPT",
  "SNAPCHAT",
  "TIKTOK",
  "GOOGLEADS",
  "SENDLANE",
  "ATTENTIVE",
  "REDO",
  "WEBHOOK",
  "UNSPECIFIED",
]);

export const createContextualIntegration = {
  name: "createContextualIntegration" as const,
  input: z.object({ type: integrationTypeSchema, name: z.string() }),
  output: IntegrationV2ResponseSchema,
};

export const bulkCreateContextualIntegrations = {
  name: "bulkCreateContextualIntegrations" as const,
  input: z.object({
    integrations: z.array(
      z.object({ type: integrationTypeSchema, name: z.string() }),
    ),
  }),
  output: z.array(IntegrationV2ResponseSchema),
};
